'use client';
import React, { useEffect } from 'react';

import { IDateFilterBarProps, IDatePickerDateProps } from '../interfaces';

// Components
import ExtendedDatePicker from './ExtendedDatePicker';
import SearchField from './SearchField';
import styled from '@benzinga/themetron';

const DateFilterBar = ({
  children,
  dateRange,
  enableDatePicker,
  hideSearch,
  onDateChange,
  onSearch,
  search,
  tagsMode = false,
  theme = 'default',
}: IDateFilterBarProps) => {
  const [dateStart, setDateStart] = React.useState(dateRange ? dateRange.date_from : null);
  const [dateEnd, setDateEnd] = React.useState(dateRange ? dateRange.date_to : null);

  useEffect(() => {
    setDateStart(dateRange.date_from);
    setDateEnd(dateRange.date_to);
  }, [dateRange]);

  function handleDatePickerChange({ end, start }: IDatePickerDateProps) {
    onDateChange({ end, interval: true, start });
  }

  return (
    <DateFiltersWrapper className={`${theme === 'modern' ? 'new-date-picker-style' : ''}`}>
      <div className="dates-filter">
        {enableDatePicker && (
          <ExtendedDatePicker end={dateEnd} onChangeDate={handleDatePickerChange} start={dateStart} />
        )}

        {children}

        {!hideSearch ? (
          <SearchField onSearch={onSearch} placeholder="Filter by Tickers..." search={search} tagsMode={tagsMode} />
        ) : (
          ''
        )}
      </div>
    </DateFiltersWrapper>
  );
};

export default DateFilterBar;

export const DateFiltersWrapper = styled.div`
  flex-grow: 1;

  .ratings-filters {
    display: inline-flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1rem;
    position: relative;

    .range-date-picker {
      &__field-wrapper {
        font-size: 12px;
        width: 200px;
        font-weight: bold;

        @media screen and (max-width: 500px) {
          width: 185px;
          padding: 0;
        }
      }
    }

    @media screen and (max-width: 500px) {
      .dates-filter {
        display: inline-flex;
        align-items: center;
        .range-date-picker {
          padding: 0;
        }
        .bz3-search-field {
          width: 160px;
          input.bz3-search-field__input {
            width: 92px;
          }
        }
      }
    }
  }

  .dates-filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .range-date-picker {
      max-width: 280px;
      position: static;

      .DayPicker-NavButton--prev {
        top: 13px;
        left: 41px;
      }

      .DayPicker-NavButton--next {
        top: 13px;
        right: 41px;
      }
    }

    .bz3-search-field {
      max-width: 180px;
      margin-left: 10px;
      width: 180px;

      &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // @media screen and (max-width: 1300px) {
      //   max-width: 200px;
      //   width: 200px;
      // }

      //@media screen and (max-width: 1000px) {
      //  margin-left: auto;
      //}

      @media screen and (max-width: 500px) {
        max-width: 100%;
        margin-left: auto;
        width: 100%;
      }
    }

    &__slider {
      max-width: 75%;
      width: 100%;

      @media screen and (max-width: 1000px) {
        margin-bottom: 20px;
        max-width: none;
      }
    }

    .react-datepicker-popper[data-placement^='bottom'] {
      .react-datepicker__triangle {
        &:before {
          border: none !important;
          border-bottom-color: #fff !important;
        }
      }
    }

    .react-datepicker {
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      border: none;
      &__header {
        background-color: #fff;
        border-bottom-color: #f0f0f0;
      }

      &__day {
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0);
        &:hover {
          border: 1px solid #fa8418;
          background: none;
        }

        &:focus {
          outline: none;
        }

        &--in-range,
        &--in-selecting-range {
          background-color: rgba(250, 132, 24, 0.5);
          &:hover {
            color: #000;
          }
        }

        &--selected,
        &--keyboard-selected {
          background-color: #fa8418;
          &:hover {
            background-color: #fa8418;
          }
        }
      }
    }

    .react-datepicker__input-container {
      position: relative;

      //&:after {
      //  content: '';
      //  top: 9px;
      //  left: 8px;
      //  position: absolute;
      //  width: 13px;
      //  height: 14px;
      //  background: url('/static/images/icons/table/date.svg') no-repeat;
      //  pointer-events: none;
      //  cursor: pointer;
      //}
    }
  }
  .range-date-picker {
    text-align: right;
    display: flex;
    align-items: center;
    padding-left: 15px;
    position: relative;

    &__icon {
      position: absolute;
      top: 16px;
      right: 10px;
      color: grey;
      pointer-events: none;
    }

    .react-datepicker-wrapper {
      width: 100%;
    }

    &__label {
      font-weight: bold;
      font-size: 14px;
      line-height: 22px;
      margin-right: 8px;
    }

    &__field-wrapper {
      width: 177px;
      max-width: 223px;
      position: relative;
      font-size: 12px;
      font-weight: 700;

      //&:after {
      //  content: '';
      //  top: 14px;
      //  right: 10px;
      //  position: absolute;
      //  width: 13px;
      //  height: 14px;
      //  background: url('/static/images/icons/table/date.svg') no-repeat;
      //  cursor: pointer;
      //  pointer-events: none;
      //}
    }

    &__calendar-wrapper {
      position: absolute;
      right: 0;
      top: 46px;
      z-index: 10;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 480px;
    }

    &__picker-field {
      padding-left: 32px;
      border-radius: 2px;
      border: 1px solid #e5e5e5;
      line-height: 22px;
      padding: 5px 10px;
      box-shadow: none;
      width: 100%;
      margin-bottom: 0;
      height: 44px;
      cursor: pointer;
      padding-right: 26px;

      &:focus {
        box-shadow: none;
        border-color: #2ca2d1;
      }
    }

    &__presets {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 5px 20px;
      width: 100%;
      justify-content: space-between;
    }

    &__preset-btn {
      padding: 5px 5px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 24px;
      width: 21%;
      margin-bottom: 15px;
      border-radius: 5px;

      &:hover {
        background-color: #fa84188c;
      }
    }

    .DayPicker {
      &-Month {
        margin: 1em 1em 0;
      }

      &-Months {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }
      &-NavButton {
        &--prev {
          top: 20px;
          left: 17px;
        }

        &--next {
          top: 20px;
          right: 10px;
        }
      }

      &-Caption {
        text-align: center;
        padding-bottom: 10px;
        border-bottom: 1px solid #f0f0f0;
      }

      &-Week,
      &-WeekdaysRow {
        display: flex;
      }

      &-Weekday {
        text-align: center;
        font-size: 14px;
        width: 24px;
        height: 24px;
        padding: 1px;
        display: block;
        margin: 1px;
        cursor: pointer;
      }

      &-Day {
        border: 1px solid rgba(0, 0, 0, 0);
        border-radius: 2px;
        display: block;
        width: 24px;
        height: 24px;
        padding: 1px;
        text-align: center;
        vertical-align: middle;
        font-size: 14px;
        line-height: 20px;
        margin: 1px;
        cursor: pointer;

        &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
          background-color: rgba(250, 132, 24, 0.5);
        }

        &--start,
        &--end {
          &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: #fa8418;
          }
        }

        &:hover {
          &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: rgba(0, 0, 0, 0);
            border: 1px solid #fa8418;
            color: #000;
          }
        }
      }
    }
  }

  .DayPicker-NavButton--prev {
    margin-right: 1.5em;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC);
  }

  .DayPicker-NavButton--next {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==);
  }

  .DayPicker-NavButton {
    position: absolute;
    top: 1em;
    right: 1.5em;
    left: auto;
    display: inline-block;
    margin-top: 2px;
    width: 1.25em;
    height: 1.25em;
    background-position: 50%;
    background-size: 50%;
    background-repeat: no-repeat;
    color: #8b9898;
    cursor: pointer;
  }

  &.new-date-picker-style {
    .range-date-picker {
      text-align: right;
      display: flex;
      align-items: center;
      padding-left: 15px;

      &__icon {
        top: 12px;
        color: #5b7292;
      }

      &__calendar-wrapper {
        position: absolute;
        right: 0;
        top: 46px;
        z-index: 11;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: fit-content;
        max-width: 480px;
      }

      &__picker-field {
        background-color: #f2f8ff;
        padding-left: 32px;
        border-radius: 2px;
        line-height: 22px;
        padding: 5px 10px;
        box-shadow: none;
        width: 100%;
        margin-bottom: 0;
        height: 36px;
        cursor: pointer;
        padding-right: 26px;
        color: #5b7292;
        border: none;
        border-radius: 2px;

        &:focus {
          box-shadow: none;
          border-color: transparent;
          outline: none;
        }
      }

      &__presets {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 0.5rem;
        width: 100%;
        justify-content: space-between;
      }

      &__preset-btn {
        padding: 4px 8px;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        width: fit-content;
        border-radius: 2px;
        margin-bottom: 0;

        &:hover {
          background-color: #f2f8ff;
        }
      }

      .DayPicker {
        &-Month {
          margin: 1em 1em 0;
        }

        &-Months {
          display: flex;
          justify-content: center;
          flex-wrap: nowrap;
        }
        &-NavButton {
          &--prev {
            top: 20px;
            left: 17px;
          }

          &--next {
            top: 20px;
            right: 10px;
          }
        }

        &-Caption {
          text-align: center;
          padding-bottom: 8px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 14px;
        }

        &-Week,
        &-WeekdaysRow {
          display: flex;
        }

        &-Weekday {
          text-align: center;
          font-size: 14px;
          width: 24px;
          height: 24px;
          padding: 2px;
          display: block;
          margin: 0px;
          cursor: pointer;
          abbr {
            text-decoration: none;
            font-size: 12px;
            color: #5b7292;
          }
        }

        &-Day {
          border: 1px solid rgba(0, 0, 0, 0);
          border-radius: 0;
          display: block;
          width: 24px;
          height: 24px;
          padding: 2px;
          text-align: center;
          vertical-align: middle;
          font-size: 14px;
          line-height: 20px;
          margin: 0px;
          cursor: pointer;

          &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background-color: #82b4f94b;
          }

          &--start,
          &--end {
            &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
              background-color: #3f83f8;
              color: white;
            }
          }
          &--start {
            border-radius: 4px 0 0 4px;
          }

          &--end {
            border-radius: 0 4px 4px 0;
          }

          &:hover {
            &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
              background-color: rgba(0, 0, 0, 0);
              border: 1px solid #82b4f9;
              border-radius: 2px;
              color: black;
            }
          }
        }
      }
    }

    .DayPicker-NavButton--prev {
      top: 16px;
      margin-right: 1.5em;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC);
    }

    .DayPicker-NavButton--next {
      top: 16px;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==);
    }

    .DayPicker-NavButton {
      width: 16px;
      height: 16px;
    }

    .bz3-search-field {
      position: relative;
      max-width: 180px;
      background-color: #f2f8ff;
      margin: 0;
      margin-left: 1rem;

      &__tags-wrapper {
        border: none;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        height: auto;
        min-height: 36px;
        padding: 0 32px 0 15px;
        border-radius: 2px;
        box-shadow: none;
        margin: 0;
        background-color: #f2f8ff;
      }

      &__btn {
        height: 32px;
        width: 32px;
        border: 0;
        /* background: #3f83f8; */
        background-color: transparent;
        color: #3f83f8;
        font-size: 14px;
        position: absolute;
        top: 2px;
        right: 2px;
      }

      &__input {
        border: none;
        width: 100%;
        padding: 0;
        font-size: 12px;
        background-color: #f2f8ff;

        &::placeholder {
          color: #5b7292;
        }

        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }

    @media (max-width: 800px) {
      .dates-filter {
        margin-bottom: 0.5rem;
      }
    }
  }
`;
